/** Avatar — Radix-based with elegant fallback (initials + gradient). */
import { forwardRef } from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "../../lib/cn";

const sizes = {
  xs: "w-6 h-6 text-[10px]",
  sm: "w-8 h-8 text-[11.5px]",
  md: "w-10 h-10 text-[13px]",
  lg: "w-14 h-14 text-[16px]",
  xl: "w-20 h-20 text-[22px]",
};

const GRADIENTS = [
  "linear-gradient(135deg,#7E3A82,#4E1C50)",
  "linear-gradient(135deg,#9C7B98,#5a3a55)",
  "linear-gradient(135deg,#768071,#42493e)",
  "linear-gradient(135deg,#C0A36B,#7a6336)",
  "linear-gradient(135deg,#5a6b7a,#2f3a42)",
];

export function gradientFor(seed) {
  const i = typeof seed === "string"
    ? seed.split("").reduce((a, c) => a + c.charCodeAt(0), 0)
    : (seed || 0);
  return GRADIENTS[i % GRADIENTS.length];
}

export const Avatar = forwardRef(function Avatar(
  { className, size = "md", initials, src, alt, seed, ...props },
  ref
) {
  return (
    <AvatarPrimitive.Root
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center rounded-full overflow-hidden font-semibold text-white",
        sizes[size],
        className
      )}
      style={{ background: gradientFor(seed ?? initials ?? 0) }}
      {...props}
    >
      {src && <AvatarPrimitive.Image src={src} alt={alt} className="w-full h-full object-cover" />}
      <AvatarPrimitive.Fallback delayMs={120}>{initials}</AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
});
